export default function getListingMode(experiences = [], isB2BUser = false) {
    let mode = 'grid-default';
    if (isB2BUser) {
        if (experiences.includes('b2b-card-grid-visual')) {
            mode = 'grid-visual';
        } else if (experiences.includes('b2b-card-list-default')) {
            mode = 'list-default';
        } else if (experiences.includes('b2b-card-list-spec')) {
            mode = 'list-spec';
        }
    } else if (experiences.includes('b2c-card-grid-visual')) {
        mode = 'grid-visual';
    } else if (experiences.includes('b2c-card-list-spec')) {
        mode = 'list-spec';
    } else if (experiences.includes('b2c-card-list-default')) {
        mode = 'list-default';
    }
    return mode;
}
